// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Product Hero Section Styles */

/* Registered custom properties for smooth gradient animation */
@property --hero-s3-o {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.5;
}

@property --hero-s5-a {
  syntax: '<angle>';
  inherits: false;
  initial-value: 152.86deg;
}

@property --hero-s6-o {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.5;
}

@property --hero-s6-a {
  syntax: '<angle>';
  inherits: false;
  initial-value: 161.43deg;
}

@property --hero-s7-o {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.61;
}

@property --hero-s8-o {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.8;
}

@property --hero-s9-o {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.61;
}

@property --hero-s10-o {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.5;
}

@property --hero-s10-a {
  syntax: '<angle>';
  inherits: false;
  initial-value: 199.18deg;
}

@property --hero-s11-a {
  syntax: '<angle>';
  inherits: false;
  initial-value: 207.21deg;
}

.scl--web-page-product-hero-section-box {
  width: 100%;
  height: 100vh;
  max-height: 1186px;
  background: #000000;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

/* Hero Section */
.scl--web-page-product-hero-section {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 10;
}

.scl--web-page-product-hero-section-container {
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
}

.scl--web-page-product-hero-section-box .scl--web-page-product-hero-section .scl--web-component-hero-content .scl--web-component-hero-title {
  max-width: 800px;
}

.scl--web-page-product-hero-bg-effect {
  position: absolute;
  width: 100%;
  height: 100vh;
  max-height: 1212px;
  overflow: hidden;
  display: flex;
  justify-content: end;
  right: 0;
}

.scl--web-page-product-hero-bg-gradient {
  width: 40%;
  position: relative;
  inset: 0;

  background: conic-gradient(from 270deg at 0% 50%,

      #CE7D63 -17.29deg,
      #E9F3FF 0.14deg,
      rgba(206, 125, 99, 0.5) 18.03deg,

      transparent 53.94deg,
      transparent 152.86deg,

      rgba(206, 125, 99, 0.5) 161.43deg,
      rgba(206, 125, 99, 0.61) 167.3deg,
      rgba(233, 243, 255, 0.8) 179.85deg,
      rgba(206, 125, 99, 0.61) 192.89deg,
      rgba(206, 125, 99, 0.5) 199.18deg,

      transparent 207.21deg,
      transparent 304.57deg,

      #CE7D63 342.71deg,
      #E9F3FF 360.14deg);

  transform-origin: left center;
  animation: beamZoom 4s ease-in-out infinite;
  opacity: 0.85;
}




@keyframes heroGradientPulse {
  0% {
    --hero-s3-o: 0.5;
    --hero-s5-a: 152.86deg;
    --hero-s6-o: 0.5;
    --hero-s6-a: 161.43deg;
    --hero-s7-o: 0.61;
    --hero-s8-o: 0.8;
    --hero-s9-o: 0.61;
    --hero-s10-o: 0.5;
    --hero-s10-a: 199.18deg;
    --hero-s11-a: 207.21deg;
  }

  100% {
    --hero-s3-o: 1;
    --hero-s5-a: 147.65deg;
    --hero-s6-o: 0.55;
    --hero-s6-a: 162deg;
    --hero-s7-o: 0.68;
    --hero-s8-o: 0.9;
    --hero-s9-o: 0.68;
    --hero-s10-o: 0.55;
    --hero-s10-a: 198.63deg;
    --hero-s11-a: 212.24deg;
  }
}

.scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button {
  height: 40px;
  min-width: 152px;
  background: linear-gradient(180deg, #181818 0%, #111111 100%);
  border: 1.5px solid #252525;
}

.scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button:hover {
  border: 1px solid white;
}

.scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button-text {
  font-size: 16px;
}

/* Responsive Design */

@media screen and (max-width: 1728px) {
  .scl--web-page-product-hero-section-container {
    padding-left: var(--global-laptop-padding-left);
    padding-right: var(--global-laptop-padding-right);
  }

  .scl--web-page-product-hero-bg-effect {
    width: 80%;
  }

  .scl--web-page-product-hero-bg-gradient {
    width: 48%;
  }
}

@media screen and (max-width: 1280px) {
  .scl--web-page-product-hero-section .scl--web-component-hero-title-line1 {
    font-size: 90px;
  }

  .scl--web-page-product-hero-section .scl--web-component-hero-title-line2 {
    font-size: 90px;
  }
}

@media screen and (max-width: 850px) {
  .scl--web-page-product-hero-section {
    padding: 0px var(--global-tablet-padding-left);
    height: 100vh
  }

  .scl--web-page-product-hero-bg-effect {
    width: 100%;
  }

  .scl--web-page-product-hero-bg-gradient {
    width: 40%;
    background: conic-gradient(from 270deg at 0% 50%,

        #CE7D63 -20deg,
        #E9F3FF 0deg,
        rgba(206, 125, 99, 0.5) 20deg,

        transparent 65deg,
        transparent 145deg,

        rgba(206, 125, 99, 0.5) 160deg,
        rgba(206, 125, 99, 0.61) 172deg,
        rgba(233, 243, 255, 0.8) 180deg,
        rgba(206, 125, 99, 0.61) 188deg,
        rgba(206, 125, 99, 0.5) 200deg,

        transparent 215deg,
        transparent 285deg,

        #CE7D63 335deg,
        #E9F3FF 360deg);
  }

  .scl--web-page-product-hero-section .scl--web-component-hero-title {
    font-weight: 400;
    font-style: normal;
    font-size: 90px;
  }

  .scl--web-page-product-hero-section-container {
    padding: 0px;
  }

  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button {
    width: 233px;
    height: 50px;
    border-radius: 30px;
  }

  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button-text {
    font-size: 24px;
  }

}

@media screen and (max-width: 500px) {
  .scl--web-page-product-hero-section {
    padding: 0px var(--global-mobile-padding-left);
    max-height: 956px;
  }

  .scl--web-page-product-hero-section .scl--web-component-hero-title {
    font-weight: 400;
    font-style: normal;
    font-size: 50px;
    line-height: 80px;
    letter-spacing: 0px;
    vertical-align: middle;

  }

  .scl--web-page-product-hero-section .scl--web-component-hero-title-line1 {
    font-size: 50px;
    line-height: 60px;
  }

  .scl--web-page-product-hero-section .scl--web-component-hero-title-line2 {
    font-size: 55px;
  }

  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button {
    height: 50px;
    width: 250px;
    border-radius: 25px;
  }

  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button-text {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/product/css/productHero.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;;EAER;;;;;;;;;;;;;;;;;;;wBAmBsB;;EAEtB,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;AACf;;;;;AAKA;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;;AAEtB;EACE;IACE,+CAA+C;IAC/C,iDAAiD;EACnD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,8CAA8C;IAC9C;EACF;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV;;;;;;;;;;;;;;;;;;;uBAmBmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,8CAA8C;IAC9C,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;;EAExB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Product Hero Section Styles */\n\n/* Registered custom properties for smooth gradient animation */\n@property --hero-s3-o {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.5;\n}\n\n@property --hero-s5-a {\n  syntax: '<angle>';\n  inherits: false;\n  initial-value: 152.86deg;\n}\n\n@property --hero-s6-o {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.5;\n}\n\n@property --hero-s6-a {\n  syntax: '<angle>';\n  inherits: false;\n  initial-value: 161.43deg;\n}\n\n@property --hero-s7-o {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.61;\n}\n\n@property --hero-s8-o {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.8;\n}\n\n@property --hero-s9-o {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.61;\n}\n\n@property --hero-s10-o {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.5;\n}\n\n@property --hero-s10-a {\n  syntax: '<angle>';\n  inherits: false;\n  initial-value: 199.18deg;\n}\n\n@property --hero-s11-a {\n  syntax: '<angle>';\n  inherits: false;\n  initial-value: 207.21deg;\n}\n\n.scl--web-page-product-hero-section-box {\n  width: 100%;\n  height: 100vh;\n  max-height: 1186px;\n  background: #000000;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n\n/* Hero Section */\n.scl--web-page-product-hero-section {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 10;\n}\n\n.scl--web-page-product-hero-section-container {\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n}\n\n.scl--web-page-product-hero-section-box .scl--web-page-product-hero-section .scl--web-component-hero-content .scl--web-component-hero-title {\n  max-width: 800px;\n}\n\n.scl--web-page-product-hero-bg-effect {\n  position: absolute;\n  width: 100%;\n  height: 100vh;\n  max-height: 1212px;\n  overflow: hidden;\n  display: flex;\n  justify-content: end;\n  right: 0;\n}\n\n.scl--web-page-product-hero-bg-gradient {\n  width: 40%;\n  position: relative;\n  inset: 0;\n\n  background: conic-gradient(from 270deg at 0% 50%,\n\n      #CE7D63 -17.29deg,\n      #E9F3FF 0.14deg,\n      rgba(206, 125, 99, 0.5) 18.03deg,\n\n      transparent 53.94deg,\n      transparent 152.86deg,\n\n      rgba(206, 125, 99, 0.5) 161.43deg,\n      rgba(206, 125, 99, 0.61) 167.3deg,\n      rgba(233, 243, 255, 0.8) 179.85deg,\n      rgba(206, 125, 99, 0.61) 192.89deg,\n      rgba(206, 125, 99, 0.5) 199.18deg,\n\n      transparent 207.21deg,\n      transparent 304.57deg,\n\n      #CE7D63 342.71deg,\n      #E9F3FF 360.14deg);\n\n  transform-origin: left center;\n  animation: beamZoom 4s ease-in-out infinite;\n  opacity: 0.85;\n}\n\n\n\n\n@keyframes heroGradientPulse {\n  0% {\n    --hero-s3-o: 0.5;\n    --hero-s5-a: 152.86deg;\n    --hero-s6-o: 0.5;\n    --hero-s6-a: 161.43deg;\n    --hero-s7-o: 0.61;\n    --hero-s8-o: 0.8;\n    --hero-s9-o: 0.61;\n    --hero-s10-o: 0.5;\n    --hero-s10-a: 199.18deg;\n    --hero-s11-a: 207.21deg;\n  }\n\n  100% {\n    --hero-s3-o: 1;\n    --hero-s5-a: 147.65deg;\n    --hero-s6-o: 0.55;\n    --hero-s6-a: 162deg;\n    --hero-s7-o: 0.68;\n    --hero-s8-o: 0.9;\n    --hero-s9-o: 0.68;\n    --hero-s10-o: 0.55;\n    --hero-s10-a: 198.63deg;\n    --hero-s11-a: 212.24deg;\n  }\n}\n\n.scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button {\n  height: 40px;\n  min-width: 152px;\n  background: linear-gradient(180deg, #181818 0%, #111111 100%);\n  border: 1.5px solid #252525;\n}\n\n.scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button:hover {\n  border: 1px solid white;\n}\n\n.scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button-text {\n  font-size: 16px;\n}\n\n/* Responsive Design */\n\n@media screen and (max-width: 1728px) {\n  .scl--web-page-product-hero-section-container {\n    padding-left: var(--global-laptop-padding-left);\n    padding-right: var(--global-laptop-padding-right);\n  }\n\n  .scl--web-page-product-hero-bg-effect {\n    width: 80%;\n  }\n\n  .scl--web-page-product-hero-bg-gradient {\n    width: 48%;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .scl--web-page-product-hero-section .scl--web-component-hero-title-line1 {\n    font-size: 90px;\n  }\n\n  .scl--web-page-product-hero-section .scl--web-component-hero-title-line2 {\n    font-size: 90px;\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .scl--web-page-product-hero-section {\n    padding: 0px var(--global-tablet-padding-left);\n    height: 100vh\n  }\n\n  .scl--web-page-product-hero-bg-effect {\n    width: 100%;\n  }\n\n  .scl--web-page-product-hero-bg-gradient {\n    width: 40%;\n    background: conic-gradient(from 270deg at 0% 50%,\n\n        #CE7D63 -20deg,\n        #E9F3FF 0deg,\n        rgba(206, 125, 99, 0.5) 20deg,\n\n        transparent 65deg,\n        transparent 145deg,\n\n        rgba(206, 125, 99, 0.5) 160deg,\n        rgba(206, 125, 99, 0.61) 172deg,\n        rgba(233, 243, 255, 0.8) 180deg,\n        rgba(206, 125, 99, 0.61) 188deg,\n        rgba(206, 125, 99, 0.5) 200deg,\n\n        transparent 215deg,\n        transparent 285deg,\n\n        #CE7D63 335deg,\n        #E9F3FF 360deg);\n  }\n\n  .scl--web-page-product-hero-section .scl--web-component-hero-title {\n    font-weight: 400;\n    font-style: normal;\n    font-size: 90px;\n  }\n\n  .scl--web-page-product-hero-section-container {\n    padding: 0px;\n  }\n\n  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button {\n    width: 233px;\n    height: 50px;\n    border-radius: 30px;\n  }\n\n  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button-text {\n    font-size: 24px;\n  }\n\n}\n\n@media screen and (max-width: 500px) {\n  .scl--web-page-product-hero-section {\n    padding: 0px var(--global-mobile-padding-left);\n    max-height: 956px;\n  }\n\n  .scl--web-page-product-hero-section .scl--web-component-hero-title {\n    font-weight: 400;\n    font-style: normal;\n    font-size: 50px;\n    line-height: 80px;\n    letter-spacing: 0px;\n    vertical-align: middle;\n\n  }\n\n  .scl--web-page-product-hero-section .scl--web-component-hero-title-line1 {\n    font-size: 50px;\n    line-height: 60px;\n  }\n\n  .scl--web-page-product-hero-section .scl--web-component-hero-title-line2 {\n    font-size: 55px;\n  }\n\n  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button {\n    height: 50px;\n    width: 250px;\n    border-radius: 25px;\n  }\n\n  .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button-text {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
